import axios from "axios";
axios.defaults.withXSRFToken = true;
export const HTTP = axios.create({
    withCredentials: true,
    baseURL: process.env.NEXT_PUBLIC_BACKEND_API || 'http://localhost:8000/api'
})